var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('WidgetPreviewBox',{attrs:{"device":_vm.device,"formData":_vm.widgetConfigProps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }